import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useApp } from '../contexts/AppContext';
import { Field, useL } from './Kit';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Select school → select student. onChange({school, student}) */
export default function StudentPicker({ onChange, testId = 'student-picker', showGradeFilter }) {
  const { currentSchool, lang } = useApp();
  const { L } = useL();
  const [schools, setSchools] = useState([]);
  const [students, setStudents] = useState([]);
  const [schoolId, setSchoolId] = useState(currentSchool?.school_id || '');
  const [studentId, setStudentId] = useState('');
  const [grade, setGrade] = useState('');

  useEffect(() => { axios.get(`${API}/schools`).then(r => { setSchools(r.data); if (!schoolId && r.data[0]) setSchoolId(r.data[0].school_id); }).catch(() => {}); }, []); // eslint-disable-line
  useEffect(() => { if (!schoolId) return; axios.get(`${API}/schools/${schoolId}/students`).then(r => setStudents(r.data)).catch(() => setStudents([])); setStudentId(''); }, [schoolId]);
  useEffect(() => { onChange?.({ school: schools.find(s => s.school_id === schoolId), student: students.find(s => s.student_id === studentId) }); }, [schoolId, studentId, schools, students]); // eslint-disable-line

  const visible = grade ? students.filter(s => String(s.grade) === grade) : students;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <Field en="School" bn="বিদ্যালয়">
        <select data-testid={`${testId}-school`} className="input-filled" value={schoolId} onChange={e => setSchoolId(e.target.value)}>
          {schools.map(s => <option key={s.school_id} value={s.school_id}>{lang === 'bn' ? s.name_bangla : s.name_english}</option>)}
        </select>
      </Field>
      {showGradeFilter && (
        <Field en="Grade" bn="শ্রেণি">
          <select data-testid={`${testId}-grade`} className="input-filled" value={grade} onChange={e => setGrade(e.target.value)}>
            <option value="">{L('All grades', 'সব শ্রেণি')}</option>
            {[...new Set(students.map(s => s.grade))].sort((a, b) => a - b).map(g => <option key={g} value={g}>{L('Grade', 'শ্রেণি')} {g}</option>)}
          </select>
        </Field>
      )}
      <Field en="Student" bn="শিক্ষার্থী">
        <select data-testid={`${testId}-student`} className="input-filled" value={studentId} onChange={e => setStudentId(e.target.value)} required>
          <option value="">{L('Select student', 'শিক্ষার্থী নির্বাচন করুন')}</option>
          {visible.map(s => <option key={s.student_id} value={s.student_id}>{lang === 'bn' ? s.name_bangla : (s.name_english || s.name_bangla)} — {L('Grade', 'শ্রেণি')} {s.grade}{s.section ? `-${s.section}` : ''} · {L('Roll', 'রোল')} {s.roll_number}</option>)}
        </select>
      </Field>
    </div>
  );
}
